module.exports = __webpack_public_path__ + "media/images/flags/PR-a60120c2542dddb33ecc37b45ea67728.svg";